// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"2c60c5e6","239":"9081a06e","468":"8a8f6feb","787":"645fb9ec","938":"3d85edca"}[chunkId] + ".chunk.js";
};